import { FilterType, GridComponent } from '@syncfusion/ej2-react-grids';
import { useContext, useEffect, useState } from 'react';
import { all_information, loadingShow, serviceUrl } from '../App';
import { ThemeContext } from '../context/theme.context';
import Message from '../utils/Message/Message';
import {
  ButtonPropsModel,
  DialogComponent,
} from '@syncfusion/ej2-react-popups';
import {
  AddPlanOrder,
  DeletePlanOrder,
} from '../services/ControlCenter/PlanServices';
import GlobalGrid from './GlobalGrid';
import { plannedOrderColumns } from '../layout/ControlCenter/Columns';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { BsSearch } from 'react-icons/bs';
import { applyTheRule } from '../utils/BussinesRuleBuilder';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { ChangeEventArgs } from '@syncfusion/ej2-react-buttons';
import { isArray } from 'lodash';

interface IProps {
  plan_id: number;
  getPlanOrder: (plan_id: number) => void;
  hideDialogOrder: boolean;
  setHideDialogOrder: (cond: boolean) => void;
}
var model: any = [];
var gridPlanWorkOrder: GridComponent = new GridComponent({});
var theDataForOrderRemove: Array<any> = [];
var current_query: string = '';
var theQuerySearch = '';
var theQueryPlanId = '';
var resultQuery = '';
const GlobalPlannedOrderGrid = ({
  plan_id,
  getPlanOrder,
  hideDialogOrder,
  setHideDialogOrder,
}: IProps) => {
  const [the_current_query, setThe_current_query] = useState('$');
  const [loadSignal, setLoadSignal] = useState(false);
  const [searchText, setSearchText] = useState('');
  const context = useContext(ThemeContext);
  const groupOptions = { showGroupedColumn: true };

  useEffect(() => {
    theDataForOrderRemove = [];
  }, []);
  const buttonsOrder: ButtonPropsModel[] = [
    {
      click: () => {
        SaveListPlanOrder(true);
      },
      buttonModel: {
        content: 'Apply and Close',
        isPrimary: true,
      },
    },
    {
      click: () => {
        SaveListPlanOrder(false);
      },
      buttonModel: {
        content: 'Apply',
        isPrimary: true,
      },
    },
    {
      click: () => {
        setHideDialogOrder(false);
        getPlanOrder(plan_id);
      },
      buttonModel: {
        content: 'Cancel',
      },
    },
  ];

  var gridmntObj: GridComponent;

  const onChange = (sel: {
    itemData: { text: string; value: string };
  }): void => {
    gridmntObj.filterSettings.type = sel?.itemData?.value as FilterType;
    gridmntObj.clearFiltering();
  };

  const templateMenuEl = () => {
    return (
      <div>
        <DropDownListComponent
          id='ddlelement'
          dataSource={[
            // { text: 'Menu', value: 'Menu' },
            // { text: 'Checkbox', value: 'CheckBox' },
            { text: 'Excel', value: 'Excel' },
          ]}
          fields={{ text: 'text', value: 'value' }}
          change={onChange.bind(this)}
          index={0}
          popupHeight='150px'
          width='200px'
        />
      </div>
    );
  };
  const template = () => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          alignSelf: 'flex-end',
          height: 25,
        }}
      >
        <TextBoxComponent
          type={'text'}
          id='work_orders_plan'
          autocomplete='off'
          showClearButton
          placeholder='Search'
          value={searchText}
          onChange={(args: any) => {
            setSearchText(args.target.value);
          }}
        />
        <div
          style={{
            borderRightColor: 'transparent',
            borderTopColor: 'transparent',
            borderBottomColor: 'transparent',
          }}
        >
          <BsSearch
            color={context.isDarkMode ? '#eaeaea' : '#292525'}
            className={'searchIcon'}
            onClick={search}
          />
        </div>
      </div>
    );
  };
  const splitList = (data: any[], chunkSize: number) => {
    const result = [];
    for (let i = 0; i < data.length; i += chunkSize) {
      result.push(data.slice(i, i + chunkSize));
    }
    return result;
  };
  const search = () => {
    if (searchText !== '' || the_current_query !== '') {
      resultQuery = '';
      buildQuery(true, '');
    }
  };
  const toolbarOptionsOrder2: any = [
    'ColumnChooser',
    { template: template.bind(this) },
    //{ template: templateMenuEl.bind(this) },
  ];
  const orderTableDeSelect = (args: any) => {
    console.log('orderTableDeSelect args', args);
    if (args.isInteracted) {
      if (isArray(args.data)) {
        args.data.map((each: any) => {
          theDataForOrderRemove.push(each);
        });
      } else {
        theDataForOrderRemove.push(args.data);
      }
      theDataForOrderRemove = [...new Set(theDataForOrderRemove)];
      console.log(
        'orderTableDeSelect theDataForOrderRemove',
        theDataForOrderRemove
      );
    }
  };
  const SaveListPlanOrder = async (isClosed: boolean) => {
    const data = gridPlanWorkOrder.getSelectedRecords();
    let CompanyID = all_information.company_id?.toString();
    let created_by = all_information.user_id;
    let objAdd = data.map((el: any) => {
      return {
        order_code: el.order_code,
        order_id: el.order_id,
        organization_Id: CompanyID,
        created_by: created_by,
        plan_id: plan_id,
      };
    });
    console.log('theDataForOrderRemove', theDataForOrderRemove);
    let objDelete = theDataForOrderRemove.map((el: any) => {
      return {
        ...el,
        order_code: el.order_code,
        order_id: el.order_id,
        organization_Id: CompanyID,
        created_by: created_by,
        plan_id: plan_id,
      };
    });
    if (objDelete.length > 0) {
      await deleteOrderPlan(objDelete, plan_id, false).then(() => {
        theDataForOrderRemove = [];
      });
    }
    if (objAdd.length > 0) {
      var list: any[] = [];
      if (objAdd.length > 400) {
        list = splitList(objAdd, 400);
      } else {
        list = [objAdd];
      }
      loadingShow(true);

      for (let index = 0; index < list.length; index++) {
        const element = list[index];
        await AddPlanOrder(element)
          .then((res: any) => {})
          .catch((err: any) => {
            if (err.response) {
              Message.error(
                err.response.data +
                  '\n' +
                  err.response.status +
                  '\n' +
                  err.response.headers
              );
            } else if (err.request) {
              Message.error(err.request);
            } else {
              Message.error('Error: ' + err.message);
            }
            loadingShow(false);
          });
      }
      Message.success('Success');
      console.log('isClosed', isClosed);

      loadingShow(false);
    }
    if (isClosed) {
      console.log('isClosed', isClosed);
      getPlanOrder(plan_id);
      setHideDialogOrder(false);
    }
  };
  const deleteOrderPlan = async (
    obj: any,
    plan_id: number,
    fetchData: boolean
  ) => {
    await DeletePlanOrder(obj)
      .then((res: any) => {
        Message.success('Success');
        if (fetchData) {
          getPlanOrder(plan_id);
        }
        loadingShow(false);
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  };
  const openDialogOrder = () => {
    // setState({ hideDialogOrder: true });
  };
  const closeDialogOrder = () => {
    setHideDialogOrder(false);
  };
  const buildQuery = (clearRequest: boolean, additionalQuery: string) => {
    current_query = additionalQuery + the_current_query.trimEnd();
    current_query = current_query.replace(theQuerySearch, '');
    current_query = current_query.replace(theQueryPlanId, '');
    theQuerySearch = '';
    theQueryPlanId = '';
    if (searchText !== '') {
      theQuerySearch = searchText;
      current_query = current_query + theQuerySearch;
    }
    if (plan_id !== -1) {
      theQueryPlanId = '$' + plan_id;
      current_query = current_query + theQueryPlanId;
    }
    if (clearRequest) {
      model = [];
    }
    setLoadSignal(true);
    setThe_current_query(current_query + ' ');
  };
  useEffect(() => {
    const theRule = async () => {
      let theResult = await applyTheRule('job5mfj', 'Cloud Planner');
      if (theResult !== '') {
        Message.info(
          'The query is applied from the rule. Consider to remove it from the rules'
        );
      }
      theSet(theResult);
    };
    theRule();
    const theSet = (value: string) => {
      buildQuery(true, value);
    };
    return () => {};
  }, []);

  return (
    <DialogComponent
      isModal={true}
      id='defaultdialogControlCenterPlanOrder'
      showCloseIcon={true}
      visible={hideDialogOrder}
      header='Work Orders'
      buttons={buttonsOrder}
      open={openDialogOrder}
      close={closeDialogOrder}
      created={() => {}}
      width={window.innerWidth - 150}
    >
      <div className='plan-grid-3'>
        <GlobalGrid
          id='cloud-planner-workorders'
          columns={plannedOrderColumns}
          height={'45vh'}
          query={the_current_query}
          toolbarOptions={toolbarOptionsOrder2}
          get_query={`order/order-merge-by-planned-order/${600}`}
          signalOfLoad={loadSignal}
          gridRef={(grid: GridComponent) => {
            gridPlanWorkOrder = grid;
            gridmntObj = grid;
          }}
          allowCheckBox={false}
          rowDeselected={orderTableDeSelect.bind(this)}
          groupSettings={groupOptions}
        />
      </div>
    </DialogComponent>
  );
};

export default GlobalPlannedOrderGrid;
